<template>
  <div :class="['meeting-item', direction]">
    <div class="content">
      <h3 @click="handleMeetingDetails">
        {{ item.MeetingName }}
      </h3>
      <p>
        {{ item.MeetingContentDescribe }}
      </p>
      <div class="info">
        <span>时间：{{ SignUpStartDate }}至{{ SignUpStopDate }}</span>
        <span> 地点：{{ item.MeetingAddress }} </span>
      </div>
      <div>
        <ButtonCom
          :btnOption="btnOption"
          @click="handleMeetingDetails"
        ></ButtonCom>
      </div>
    </div>
    <div class="banner" @click="handleMeetingDetails">
      <img :src="MeetingImageUrl" :alt="meeting_title" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, toRefs, ref, PropType, reactive } from 'vue'
import { useRouter, Router } from 'vue-router'

import { parseTime, compareTime } from '@/utils/filter/timer'

import { meeting_title } from '@/utils/constant'
import ButtonCom from '@/components/ButtonCom/index.vue'
import { IButtonOptions } from '@/typings/common'

interface IItem {
  MeetingID: string
  SignUpStartDate: string
  SignUpStopDate: string
  ChargeOrNot: boolean
  MeetingImageUrl: string
  MeetingName: string
}

const currDate = new Date().toString()
export default defineComponent({
  components: {
    ButtonCom
  },
  props: {
    direction: {
      type: String,
      default: 'right'
    },
    item: {
      type: Object as PropType<IItem>,
      default: () => {
        return ref({
          SignUpStartDate: currDate,
          SignUpStopDate: currDate,
          ChargeOrNot: true,
          MeetingName: '会议名异常',
          MeetingImageUrl: '/UploadFile/common/meeting-not404.png',
          MeetingID: ''
        })
      }
    }
  },
  setup(props) {
    const { item } = toRefs(props)
    const router: Router = useRouter()
    const {
      SignUpStartDate,
      SignUpStopDate,
      ChargeOrNot,
      MeetingImageUrl,
      MeetingName,
      MeetingID
    } = toRefs(item.value)
    const isStart = compareTime(currDate, SignUpStartDate.value)
    const isEnd = compareTime(currDate, SignUpStopDate.value)
    let text = ''
    let background = ''
    console.log('ChargeOrNot', ChargeOrNot.value)
    if (!isStart) {
      text = '报名未开始'
      background = '#126BFF'
    } else if (isEnd) {
      text = '报名已结束'
      background = '#FEA912'
    } else if (isStart && !isEnd) {
      text = '报名中'
      background = '#67c23a'
    }

    if (!ChargeOrNot.value) {
      text = '免费报名'
      background = '#f56c6c'
    }

    // 免费报名 报名未开始 报名中 报名已结束 ChargeOrNot 是否需要费用
    const btnOption = reactive<IButtonOptions>({
      width: 200,
      height: 42,
      background,
      text,
      color: '#fff'
    })

    const handleMeetingDetails = () => {
      router.push({
        name: 'meeting',
        query: {
          meetingName: MeetingName.value,
          MeetingID: MeetingID.value
        }
      })
    }
    return {
      meeting_title,
      SignUpStartDate: ref(parseTime(SignUpStartDate.value, '{y}-{m}-{d}')),
      SignUpStopDate: ref(parseTime(SignUpStopDate.value, '{y}-{m}-{d}')),
      MeetingImageUrl:
        process.env.VUE_APP_BASE_URL +
        (MeetingImageUrl?.value || '/UploadFile/common/meeting-not404.png'),
      btnOption,
      handleMeetingDetails
    }
  }
})
</script>

<style scoped lang="scss">
.meeting-item {
  width: 1200px;
  height: 470px;
  padding-top: 40px;
  box-sizing: border-box;
  position: relative;
  .content {
    box-sizing: border-box;
    border: 1px solid #ccc;
    width: 754px;
    height: 430px;
    padding-top: 46px;
    h3 {
      cursor: pointer;
      width: 546px;
      color: #333;
      font-size: 24px;
      line-height: 34px;
      &:hover {
        text-decoration: underline;
      }
    }
    p {
      width: 546px;
      color: #999;
      font-size: 14px;
      line-height: 20px;
      margin-top: 22px;
      margin-bottom: 40px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      min-height: 63px;
    }
    .info {
      line-height: 20px;
      width: 546px;
      color: #666;
      font-size: 14px;
      margin-bottom: 34px;
      span {
        display: block;
        &:nth-child(1) {
          margin-bottom: 8px;
        }
      }
    }
  }
  .banner {
    width: 570px;
    height: 380px;
    position: absolute;
    img {
      cursor: pointer;
      width: 100%;
      height: 100%;
      transition: all 0.6s ease;
      &:hover {
        margin-top: -10px;
        box-shadow: 1px 0px 91px -3px rgba(0, 0, 0, 0.1);
      }
    }
  }
  &.left {
    .content {
      padding-right: 124px;
      padding-left: 40px;
    }
    .banner {
      right: 0px;
      top: 0px;
    }
  }
  &.right {
    padding-left: 446px;
    .content {
      padding-left: 164px;
    }
    .banner {
      left: 0px;
      top: 0px;
    }
  }
}
</style>
